// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEARCH_IN_FORUM = "Hledat v diskuz\u00edch na kon\u00edku...";
export const SEARCH_RESULTS_FOR = "V\u00fdsledky vyhled\u00e1v\u00e1n\u00ed pro slovo";
export const YOU_DID_NOT_ENTER_SEARCH_TEXT = "Zat\u00edm jsi nic nevyhledala. Napi\u0161 do vyhled\u00e1va\u010de, co bys pot\u0159ebovala v diskuz\u00edch naj\u00edt. ";
